/* eslint-disable no-param-reassign */
/* eslint-disable no-multi-assign */
/* eslint-disable react/sort-comp */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { Component } from 'react';
import {
  Card,
  CardBody,
  CardTitle,
  Col,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  UncontrolledButtonDropdown } from 'reactstrap';
import MoreHorizIcon from '@material-ui/icons/MoreHoriz';
import 'bootstrap/dist/css/bootstrap.min.css';
import NavigateNextIcon from '@material-ui/icons/NavigateNext';
import NavigateBeforeIcon from '@material-ui/icons/NavigateBefore';
import { NotificationsOffOutlined, NotificationsOutlined } from '@material-ui/icons';
import { connect } from 'react-redux';
import moment from 'utils/moment';
import styles from './events.module.scss';
import { postPortalTilesList, fetchPortalTilesList } from '../redux/actions';
import './Event.scss';

class Events extends Component {
  constructor(props) {
    super(props);
    this.state = {
      events: [],
      indexArray: []
    };
  }

  static getDerivedStateFromProps(props, state) {
    if (props.data && props.data.length > 0 && !state.events.length) {
      const sizeLimit = 2;
      const indexArray = [];
      const modify_events = [];
      props.data.forEach((val) => {
        const obj = {};
        obj.tile_name = val.tile_name;
        obj.id = val.id;
        obj.subscribed = val.subscribed;
        obj.events_len = val.events_len;
        obj.events = [];
        const slicedEvents = val.events.reduce((eventsArray, item, index) => {
          const sizeIndex = Math.floor(index / sizeLimit);
          if (!eventsArray[sizeIndex]) {
            eventsArray[sizeIndex] = [];
          }
          eventsArray[sizeIndex].push(item);
          return eventsArray;
        }, []);
        indexArray.push(0);
        obj.events = slicedEvents;
        modify_events.push(obj);
      });
      return {
        ...state,
        events: modify_events,
        indexArray
      };
    }
    return state;
  }

  selectHandler(passdata) {
    const { actionPostPortile, actionGetFetchData } = this.props;
    actionGetFetchData();
    const dataObj = (passdata.subscribed = !passdata.subscribed);
    const object = { Subscribe: dataObj };
    actionPostPortile(passdata.id, object);
  }

  loadNextEvents = (events_len, index) => {
    const { indexArray } = this.state;
    const current_index = indexArray[index];
    const limit = events_len - 1;
    if (current_index !== limit) {
      indexArray[index] = current_index + 1;
      this.setState({
        indexArray
      });
    }
  };

  loadPreviousEvents = (index) => {
    const { indexArray } = this.state;
    const current_index = indexArray[index];
    if (current_index !== 0) {
      indexArray[index] = current_index - 1;
      this.setState({
        indexArray
      });
    }
  };

  componentDidMount() {
    const { actionGetFetchData } = this.props;
    actionGetFetchData();
  }

  render() {
    const { events, indexArray } = this.state;
    return (
        <Col lg={12}>
          {events
          && events.length > 0
          && events.map((item, index) => (
              <Card key={item.id} className={styles.eventCard}>
                <CardTitle
                  className={styles.cardTitle}
                  style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center'
                  }}
                >
                  <span>{item.tile_name}</span>
                  <div className="main-drop-left d-flex">
                    <div className="dropDown cursor-pointer">
                      <UncontrolledButtonDropdown key={item.id}>
                        <DropdownToggle className="btnToggle">
                          <MoreHorizIcon />
                        </DropdownToggle>
                        <DropdownMenu>
                          <DropdownItem
                            className="activeClick"
                            onClick={() => this.selectHandler(item)}
                          >
                            {item.subscribed ? (
                              <span className="text-danger fw-bold">
                                <NotificationsOffOutlined /> Unsubscribe
                              </span>
                            ) : (
                              <span className="text-muted fw-bold">
                                <NotificationsOutlined /> Subscribe
                              </span>
                            )}
                          </DropdownItem>
                        </DropdownMenu>
                      </UncontrolledButtonDropdown>
                    </div>

                    <div className="left-right cursor-pointer">
                      {item.events_len > 2 && indexArray[index] !== 0 && (
                        <span
                          type="button"
                          className="btn"
                          onClick={() => this.loadPreviousEvents(index)}
                        >
                          <NavigateBeforeIcon />
                        </span>
                      )}
                      {item.events_len > 2
                      && indexArray[index] !== item.events.length - 1 && (
                          <span
                            type="button"
                            className="btn"
                            onClick={() => this.loadNextEvents(item.events_len, index)}
                          >
                            <NavigateNextIcon />
                          </span>
                        )}
                    </div>
                  </div>
                </CardTitle>
                <hr className={styles.hrLine} />
                <CardBody>
                  <div className={styles.dFlex}>
                    {item.events[indexArray[index]].map(i => (
                      <div key={i.id} className={styles.miniCard}>
                        <div className={styles.flex}>
                          <div>
                            <div className={styles.eventDay}>
                              <a
                                href={i.hyperlink}
                                target="_blank"
                                rel="noopener noreferrer"
                              >
                                {moment(i.date).format('D')}
                              </a>
                            </div>
                            <div className={styles.eventMonth}>
                              {moment(i.date).format('MMM')}
                            </div>
                            <div className={styles.eventYear}>
                              {moment(i.date).format('YYYY')}
                            </div>
                          </div>
                          <div className={styles.content}>
                            <div className={styles.eventName}>
                              <span> {moment(i.time).format('hh:mm A')} </span>
                              <span className={styles.diff}>-</span>
                              <a
                                href={i.hyperlink}
                                target="_blank"
                                rel="noopener noreferrer"
                              >
                                {i.name}
                              </a>
                            </div>
                            <div className={styles.eventDescription}>
                              {i.description}
                            </div>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                </CardBody>
              </Card>
            ))}
        </Col>
    );
  }
}
const mapStateToProps = state => ({
  dataList: state.home.portalTilesList
});

const mapDispatchToProps = dispatch => ({
  actionPostPortile: (id, data) => {
    dispatch(postPortalTilesList(id, data));
  },
  actionGetFetchData: () => {
    dispatch(fetchPortalTilesList());
  }
});

export default connect(mapStateToProps, mapDispatchToProps)(Events);
